var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isShow())?_c('div',{staticClass:"chat-control",on:{"click":_vm.clickShowChat}},[_c('img',{attrs:{"src":require("./assets/server.png"),"alt":"","srcset":""}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }